import { TableCell, TableRow } from "@mui/material";
import DotLegalTableWithControlsLocalized from "../../../common/components/dotLegalTableWithControlsLocalized/DotLegalTableWithControlsLocalized.tsx";
import {
    getStandardFieldsByEntityType,
    getStandardFieldTranslationKey,
    hasStandardFieldFeatureAccess,
    TemplateEntityType,
} from "../../EntityTemplate.types.ts";
import { ITableHeader } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { StandardInputFieldRow } from "../InputFields.types.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { usePlanContext } from "../../../auth/planProvider/PlanProvider.tsx";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

export interface StandardInputFieldTabProps {
    templateEntityType: TemplateEntityType;
}

function StandardInputFieldTab(props: StandardInputFieldTabProps) {
    const { translateString } = useTranslation();
    const { informationSecurityFeatures, vendorManagementFeatures, platformFeatures } = usePlanContext();

    const standardFieldHeaders = Array<ITableHeader<StandardInputFieldRow>>();
    standardFieldHeaders.push({ property: "name", text: translateString("inputField") });

    return (
        <TablePagePaper>
            <DotLegalTableWithControlsLocalized
                headers={standardFieldHeaders}
                isLoading={false}
                internalScroll
                data={getStandardFieldsByEntityType(props.templateEntityType)
                    .filter((field) => hasStandardFieldFeatureAccess(field, informationSecurityFeatures, vendorManagementFeatures, platformFeatures))
                    .map((field) => ({
                        name: translateString(getStandardFieldTranslationKey(field)),
                    }))}
                emptyText={translateString("noCustomInputFieldMatchesQuery")}
                defaultOrderBy={"name"}
                getUserSpecificPageLength={() => 100}
                clickableRows={false}
                renderRow={(row, index) => (
                    <TableRow key={row.name + index}>
                        <TableCell>{row.name}</TableCell>
                    </TableRow>
                )}
            />
        </TablePagePaper>
    );
}

export default StandardInputFieldTab;
